// eslint-disable-next-line no-shadow
export enum InputLengthCounteragent {
    common = 255,
    inn = 40,
    aliases = 1000,
  }